import { __spreadArray } from "tslib";
var defaultOptionDescription = function (option, parentGroup, selected, selectedAriaLabel) {
    var messageParts = __spreadArray(__spreadArray([
        parentGroup && parentGroup.label,
        option.value,
        option.label,
        option.description,
        option.labelTag
    ], (option.tags || []), true), [
        selected ? selectedAriaLabel : null,
    ], false).filter(function (el) { return !!el; });
    return messageParts.join(' ');
};
export default defaultOptionDescription;
//# sourceMappingURL=option-announcer.js.map